function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useIsInverseVariant as e } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: l , size: c = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = e(), h = l !== null && l !== void 0 ? l : t ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: h,
            d: "M20.802 6.202a.686.686 0 01.222.484v.692c0 .367-.331.647-.821.75a.95.95 0 01.062.295v8.479c0 .557-.521 1.005-1.169 1.005H12.39v1.664c.463.127.83.485.83 1.104 0 .787-.591 1.154-1.166 1.162h-.1c-.578-.008-1.168-.366-1.168-1.162 0-.639.383-1 .837-1.118V17.91l-6.667-.008c-.445.03-.745-.146-.899-.286a.97.97 0 01-.316-.706V8.43a.9.9 0 01.061-.295c-.246-.05-.453-.131-.59-.263a.69.69 0 01-.233-.484l.008-.692c0-.463.524-.793 1.247-.793h2.742l3.91-2.081a1.261 1.261 0 01-.1-.507c0-.796.59-1.154 1.176-1.163h.092c.577.017 1.166.384 1.166 1.168 0 .177-.031.34-.093.48l3.65 2.103h2.958c.468-.017.835.092 1.067.3zM11.55 3.31c0 .12 0 .426.423.434.476-.006.476-.314.476-.426 0-.117 0-.425-.423-.434.003-.003-.067-.003-.067-.003-.409 0-.409.308-.409.429zm-.106 1.05L8.556 5.9h6.737l-2.698-1.552a1.373 1.373 0 01-.546.132h-.084a1.399 1.399 0 01-.521-.118zm8.826 2.95s.07-.011.07-.286c0-.26-.092-.333-.092-.333-.042-.034-.138-.056-.451-.056H4.126c-.212-.002-.274-.003-.374.092-.003 0-.067.07-.065.328.003.24.115.308.115.308l.007.005c.057.042.097.07.4.07h15.57c.292-.002.469-.092.491-.128zm-.776 9.588V8.431a.232.232 0 00-.07-.176c-.053-.05-.151-.065-.269-.081H4.83c-.176.03-.322.131-.322.257v8.48a.2.2 0 00.079.167c.07.065.193.087.353.087l14.16.009c.204 0 .394-.126.394-.275zm-3.602-1.543a.381.381 0 00-.384-.367h-7.16l1.258-1.869 2.605.97c.154.056.33.01.437-.118l1.927-2.317.06.381c.024.177.193.309.377.309h.054c.215-.037.36-.222.322-.418l-.185-1.185a.383.383 0 00-.378-.308h-1.367a.37.37 0 00-.384.367v.008c.006.205.18.365.384.36h.53l-1.768 2.13-2.636-.977a.38.38 0 00-.462.149l-1.297 1.935V10.45a.377.377 0 00-.384-.367.381.381 0 00-.384.367v4.905c.006.207.177.37.384.367h8.067a.375.375 0 00.384-.367zm-3.443 5.316c0-.117 0-.42-.423-.425h-.07c-.409 0-.409.308-.409.425 0 .11 0 .426.415.426.487-.006.487-.308.487-.426z"
        })
    }));
}, m = n;
export { m as default };
